import type { AtlasInfo } from '@/features/Setting/Integrations/providers/types';
import { v1ApiClient } from '@/services/index';

const atlasService = {
  async createAtlasInfo(
    access_key: string,
    workspaceAlias: string,
  ): Promise<AtlasInfo> {
    const res = v1ApiClient.post(`/workspaces/${workspaceAlias}/atlas`, {
      access_key,
    });
    return (await res).data;
  },
  async getAtlasInfo(workspaceAlias: string): Promise<AtlasInfo> {
    const res = await v1ApiClient.get(`/workspaces/${workspaceAlias}/atlas`);
    return res.data;
  },
  async importAtlasFeedback(
    workspaceAlias: string,
    dateRange: NullableDateRangeT,
  ) {
    try {
      const res = await v1ApiClient.post(
        `/workspaces/${workspaceAlias}/atlas/import`,
        {
          start_date: dateRange.start_date,
          end_date: dateRange.end_date,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteAtlasInfo(workspaceAlias: string) {
    try {
      await v1ApiClient.delete(`/workspaces/${workspaceAlias}/atlas`);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default atlasService;
